<scitis-app-global-page-header [pageTitle]="'Groups'">
</scitis-app-global-page-header>

<div class="card mb-3">
  <div class="card-body">
    <div class="table-responsive-md">
      <table class="table vertical-align-middle mb-0">
        <thead>
          <tr>
            <th scope="col" class="sortable" style="width: 140px;" sortable="agreementAccepted"
              (sort)="onColumnSort($event)"><span translate>Name</span>
            </th>
            <th scope="col" class="sortable" sortable="displayName" (sort)="onColumnSort($event)"><span
            translate>Machines</span>
          </th>
        </tr>
      </thead>
      <tbody>
        @for (group of groups; track group) {
          <tr>
            <td [innerText]="group.name"></td>
            @for (machineGroup of group.machines; track machineGroup) {
              <td>
                <span [innerText]="machineGroup.name"></span>
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
</div>

<scitis-page-summary [itemsCount]="groups.length"
  [singleItemText]="translate.instant('Group')"
  [multipleItemsText]="translate.instant('Groups')">
</scitis-page-summary>
